import { GridColDef } from '@mui/x-data-grid-pro';
import { format } from 'date-fns';

import { PanelGrid } from 'components/grid';
import { Block } from 'components/page';
import { useQueryPreenchimento } from 'pages/financeiro/dre/preenchimento/hooks';
import { PreenchimentoColumns, PreenchimentoDetail } from 'pages/financeiro/dre/preenchimento/types';

const getRows = (preenchimentoList: PreenchimentoDetail[]): PreenchimentoColumns[] => {
    return preenchimentoList.map((preenchimento, index) => {
        const ano = new Date(`${preenchimento.dtInicio}T00:00:00`).getFullYear().toString();
        const mes = preenchimento.dsMesExtenso.toLowerCase();
        const dhAlteracao = format(new Date(preenchimento.dhAlteracao), 'dd/MM/yyyy');

        return {
            id: index,
            cdLoja: preenchimento.loja.cdLoja,
            dsNomeFantasia: preenchimento.loja.dsNomeFantasia,
            status: preenchimento.dreStatus.dsDreStatus,
            ano,
            mes,
            dhAlteracao,
        };
    });
};

const columns: GridColDef[] = [
    { field: 'cdLoja', headerName: 'Código da Loja', flex: 1, minWidth: 100 },
    { field: 'dsNomeFantasia', headerName: 'Nome da Loja', flex: 1, minWidth: 90 },
    { field: 'mes', headerName: 'Mês', flex: 1, minWidth: 70 },
    { field: 'ano', headerName: 'Ano', flex: 1, minWidth: 50 },
    { field: 'status', headerName: 'Situação', flex: 1, minWidth: 90 },
    { field: 'dhAlteracao', headerName: 'Última Alteração', flex: 1, minWidth: 110 },
];

export function PreenchimentoGrid() {
    const { data, refetch, isFetching } = useQueryPreenchimento();

    return (
        <Block>
            <PanelGrid
                rows={getRows(data?.data || [])}
                rowsCount={data?.total || 0}
                reload={refetch}
                loading={isFetching}
                columns={columns}
                remote={true}
            />
        </Block>
    );
}
